// extracted by mini-css-extract-plugin
export default {"A11yNavigation":"A11yNavigation-module--A11yNavigation--DAk9I"};